import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import SelectMenu from './selectMenu';

const Article = Styled.article`
display: block;
overflow: hidden;
border-radius: 10px;
max-width: 50rem;
border: solid 1px ${color.light};
display: grid;
grid-template-rows: 10fr max-content 10fr;
background ${color.lightAlt};
`;

// Header
const ArticleHeader = Styled.header`
display:block;
background-color: ${color.white};
display: flex;
align-items: center;
justify-content: space-between;
color: ${color.primary};
padding: 1rem 4rem;
`;
const ArticleHeading = Styled.h3`
font-size: 2rem;
`;
const ArticleAvatar = Styled.figure`
height:6rem;
width:6rem;
overflow: hidden;
border-radius: 100rem;
img{width: 100%; height: 100%; object-fit: cover;};
`;

// Body
const ArticleBody = Styled.div`
padding: 1rem 4rem;
border-top: solid 1px ${color.light};
border-bottom: solid 1px ${color.light};
`;
const ArticleList = Styled.span`
display: flex;
border-bottom: 1px solid ${color.light};
place-items: center;
padding: 1.5rem 0;
grid-gap: 1rem;
`;
const ArticleListIntro = Styled.h4`
text-transform: uppercase;
color: ${color.primaryAlt};
font-size: 1.3rem;
`;
const ArticleListOuttro = Styled.p`
color: ${color.primaryAlt};
font-size: 1.8rem;
`;
const ArticlePillsWrapper = Styled.div`
align-self: flex-start;
justify-self: flex-start;
flex: 1;
`;
const ArticlePills = Styled.span`
border-radius: 100rem;
display: inline-block;
border-radius: 5rem;
background-color: ${color.white};
color: ${color.primary};
padding: .2rem 1rem;
font-size: 1.5rem;
margin: 0 .2rem;
text-transform: capitalize;
`;

// Footer
const ArticleFooter = Styled.footer`
background-color: ${color.white};
display: flex;
align-items: center;
justify-content: space-between;
padding: 2rem 4rem;
color:${color.primary};
`;
const ArticleParagraph = Styled.p`
font-size: 1.8rem;
color: ${color.primaryAlt};
`;

class ServiceReceipt extends React.Component {
  renderPill = () => {
    let list = [];
    const days = ['M', 'T', 'W', 'TH', 'F', 'S', 'S'];
    for (let i = 0; i < this.props.recurring; i++)
      list.push(<ArticlePills>{days[i]}</ArticlePills>);
    return list;
  };

  render() {
    const { type, image, name, times, recurring, price } = this.props;
    return (
      <Article>
        <ArticleHeader>
          <ArticleHeading>
            {type} for {name}
          </ArticleHeading>
          <ArticleAvatar>
            <img src={image} alt="" />
          </ArticleAvatar>
        </ArticleHeader>

        <ArticleBody>
          <ArticleList>
            <ArticleListIntro>Service Type</ArticleListIntro>
            <ArticlePillsWrapper>
              <ArticlePills>Dog Walk</ArticlePills>
            </ArticlePillsWrapper>
            <ArticleListOuttro>
              ${price}/{type}
            </ArticleListOuttro>
          </ArticleList>

          <ArticleList>
            <ArticleListIntro>Service Time</ArticleListIntro>
            <ArticlePillsWrapper>
              {times.map((time) => (
                <ArticlePills>{time}</ArticlePills>
              ))}
            </ArticlePillsWrapper>
            <ArticleListOuttro>x {times.length}</ArticleListOuttro>
          </ArticleList>

          <ArticleList>
            <ArticleListIntro>Recurring</ArticleListIntro>
            <ArticlePillsWrapper>{this.renderPill()}</ArticlePillsWrapper>
            <ArticleListOuttro>x {recurring}</ArticleListOuttro>
          </ArticleList>

          <ArticleList>
            <ArticleListIntro>Payment Type</ArticleListIntro>
            <ArticlePillsWrapper>
              <SelectMenu
                onSelect={() => {}}
                id="options"
                options={[
                  { label: 'Master Card', value: 'Mastercard ending 2431' },
                ]}
              />
            </ArticlePillsWrapper>
          </ArticleList>
        </ArticleBody>

        <ArticleFooter>
          <ArticleHeading>Total ${price * recurring}/week</ArticleHeading>
          <ArticleParagraph>Billed weekly on Sunday</ArticleParagraph>
        </ArticleFooter>
      </Article>
    );
  }
}

export default ServiceReceipt;
